import {Injectable} from '@angular/core';
import {BaseService} from '../common/base.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SalesOrder} from './sales-order';
import {SalesOrderItem} from './sales-order-item';
import {SalesOrderTotalDTO} from './register-totals/SalesOrderTotalDTO';
import {SummedSalesOrder} from './register-totals/SummedSalesOrder';

@Injectable({
  providedIn: 'root'
})
export class SalesOrderService extends BaseService {

  private url = this.baseUrl + '/salesorder';

  private hideChecked = false;

  getSalesOrderForCheckList(orderId: number): Observable<SalesOrder> {
    return this.http.get<SalesOrder>(this.url + '/low-tax/' + orderId);
  }

  getSalesOrdersLowTax(): Observable<SalesOrder[]> {
    return this.http.get<SalesOrder[]>(this.url + '/low-tax');
  }

  getSalesOrdersForPakdag(): Observable<SalesOrder[]> {
    return this.http.get<SalesOrder[]>(this.url + '/pakdag');
  }

  getSalesOrderItemsFoSalesOrderId(salesOrderId: number): Observable<SalesOrderItem[]> {
    return this.http.get<SalesOrderItem[]>(this.baseUrl + `/salesorderitems/${salesOrderId}/salesorderitem`);
  }

  updateSalesOrderItem(item: SalesOrderItem): Observable<SalesOrderItem> {
    return this.http.put<SalesOrderItem>(this.baseUrl + '/salesorderitems/' + item.id, item);
  }

  downloadReport(): Observable<Blob> {
    return this.http
      .get(this.url + '/report', {responseType: 'blob'})
      .pipe(map(blob => new Blob([blob], {type: 'text/csv;charset=utf-8'})));
  }

  updateSalesOrder(order: SalesOrderTotalDTO): Observable<void> {
    return this.http.put<void>(this.url + '/order/' + order.id, order);
  }

  exportFustData(orders: SalesOrderTotalDTO[]): Observable<void> {
    return this.http.put<void>(this.url + '/fust-orders' , orders);
  }

  getSummedSalesOrders(): Observable<SummedSalesOrder[]> {
    return this.http.get<SummedSalesOrder[]>(this.url + '/totals');
  }

  setHideChecked(hideChecked: boolean) {
    this.hideChecked = hideChecked;
  }

  getHideChecked(): boolean {
    return this.hideChecked;
  }

}
